(function () {
	'use strict';
	angular.module('dcApp').filter('maxCountFilter', function () {
		return function (count, maxCount) {
			return count < maxCount ? '' + count : '' + maxCount + '+';
		};
	});
})();
